import ModuleContainer from './components/AxpSuppRoot';
import './iguazu-rest/config';
import './iguazu-rpc/config';
import memberProducts from './memberProducts';

memberProducts();

export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x",
  });
}
;
ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
  providedExternals: {
    
      'axp-product-ducks': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '0.3.3',
        module: require('axp-product-ducks'),
      }, 

      '@americanexpress/product-ducks': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '1.3.3',
        module: require('@americanexpress/product-ducks'),
      }, 

      'iguazu': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '3.2.0',
        module: require('iguazu'),
      }, 

      'iguazu-holocron': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '1.3.0',
        module: require('iguazu-holocron'),
      }, 

      'iguazu-rest': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '1.10.2',
        module: require('iguazu-rest'),
      }, 

      'iguazu-rpc': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '1.6.1',
        module: require('iguazu-rpc'),
      }, 

      '@americanexpress/one-experiments': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '2.1.1',
        module: require('@americanexpress/one-experiments'),
      }, 

      '@americanexpress/myca-essentials': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '3.3.0',
        module: require('@americanexpress/myca-essentials'),
      }, 

      '@americanexpress/react-ddl': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '0.1.4',
        module: require('@americanexpress/react-ddl'),
      }, 

      'iguazu-graphql': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '1.3.0',
        module: require('iguazu-graphql'),
      }, 

      'dayjs': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '1.11.13',
        module: require('dayjs'),
      }, 

      '@americanexpress/reactlytics': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '1.2.7',
        module: require('@americanexpress/reactlytics'),
      }, 

      '@emotion/core': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '10.1.1',
        module: require('@emotion/core'),
      }, 

      '@americanexpress/react-statsig-wrapper': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '0.5.1',
        module: require('@americanexpress/react-statsig-wrapper'),
      }
  },
});

if(global.getTenantRootModule === undefined || (global.rootModuleName && global.rootModuleName === 'axp-card-member-apply-root')){
global.getTenantRootModule = () => ModuleContainer;
global.rootModuleName = 'axp-card-member-apply-root';
}
